import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  message: String;
  colorMessage: String;
  iconMessage: String;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        const type = params['tipo'];
        console.log(params);
        this.message = params['mensaje'];
        this.colorMessage = this.getColorMessage(type);
        this.iconMessage =  this.getIcon(type);
      }
    );

  }

  getColorMessage (tipo) {
    switch (tipo) {
      case 'info' :
        return '#31708f';
      case 'succes' :
        return '#558B2F';
      case 'error' :
        return '#EF5350';
      default :
      return '#EF5350';
    }
  }

  getIcon(tipo) {
    switch (tipo) {
      case 'info' :
        return 'error_outline';
      case 'error' :
        return 'warning';
      default :
      return 'warning';
    }
  }

}
